import styled from "styled-components";

export const DateWrapper = styled.div`
  display: flex;
  width: 100%;
  align-itens: center;
  justify-content: center;
  text-align: center;
  font-size: 0.6rem;
  font-weight: normal;
  color: #fff;
`;

export const AppointmentCellWrapper = styled.div`
  position: absolute;
  top:0;
  left:0;
  display: flex-row;
  background-color: ${({ backgroundColor }) => backgroundColor ?? 'transparent'};
  align-items: center;
  justify-content: center;
  padding: 10px 8px;
  height: 100%;
  width: 100%;
`;

export const Appointment = styled.div`
  width: 100%;
  font-weight: bold;
  background-color: ${({ backgroundColor }) => backgroundColor ?? 'transparent'};
  color: #fff;
  font-size: 1rem;
  text-align: center;
`;